// extracted by mini-css-extract-plugin
export default {"btn":"ShareMyParkingLocationButton_btn__Slvk7","button_text":"ShareMyParkingLocationButton_button_text__IDn7W"};